import { ActionRow, ADMIN_TAG, FauxSelect, SettingsCard } from '../SettingsKit'

// Sample keywords for the keyword list wireframe.
const KEYWORDS = ['scam', 'rip off', 'fraud', 'boycott', 'fake']

export default function KeywordsTab() {
    return (
        <>
            <SettingsCard
                title="Keywords"
                description="Detect and moderate comments containing overtly toxic keywords or phrases. Keywords are case-insensitive."
            >
                <div className="py-3">
                    <div className="mb-3 flex gap-2">
                        <span className="flex-1 rounded border border-gray-200 bg-white px-2.5 py-1.5 text-xs text-gray-600">
                            Add a keyword…
                        </span>
                        <button
                            type="button"
                            className="rounded border border-dashed border-arwen-300 px-2.5 py-1 text-xs font-semibold text-arwen-700"
                        >
                            + Add
                        </button>
                    </div>
                    <div className="flex flex-wrap gap-2">
                        {KEYWORDS.map((kw) => (
                            <span
                                key={kw}
                                className="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1 text-xs text-gray-800"
                            >
                                {kw}
                                <span className="text-gray-400" aria-hidden="true">
                                    ×
                                </span>
                            </span>
                        ))}
                    </div>
                </div>
            </SettingsCard>

            <SettingsCard title="Moderation boundaries" badges={ADMIN_TAG}>
                <ActionRow
                    label="Edit moderation boundaries"
                    description="Fine-tune the thresholds for what counts as Suspect or Severe on this profile."
                    action="Open"
                />
                <ActionRow
                    label="Copy moderation settings to another team"
                    description="Duplicate this profile's boundaries and keywords across another team's profiles."
                    action="Copy"
                    badges={<FauxSelect value="Choose team" />}
                />
            </SettingsCard>
        </>
    )
}
